import { Button } from "@chakra-ui/react"
import { Link } from "react-router-dom";

const AddButton = ({ buttonText, buttonUrl }) => {
    return (
        <Link to={buttonUrl}>
            <Button
                colorScheme={"orange"}
                variant={"solid"}
                type='button'
                w={{ base: "100%", sm: "auto" }}
                size={{ base: "sm", md: "sm" }}
            >
                {buttonText ? buttonText : '新規登録'}
            </Button>
        </Link>
    )
};

export default AddButton;